import { render, staticRenderFns } from "./mentor-chats.vue?vue&type=template&id=1cbfa7d6&lang=pug"
import script from "./mentor-chats.vue?vue&type=script&lang=js"
export * from "./mentor-chats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports